import { useContext } from "react";

import { ConveniencesStore } from "../stores/conveniences";

export default function useConveniencesStore() {
  return useContext(ConveniencesStore);
}
